import React, { useEffect, useState } from 'react';
import Col from 'antd/es/col';
import Row from 'antd/es/row';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectSpotlight, selectSpotlightPulseLoading, selectSpotlightPulse, selectLoading,
} from 'Selector/SpotlightSelector';
import { selectIntentLoading, selectedIntentData } from 'Selector/FeedIntentDataSelector';
import { SpotlightFeed } from 'Types/SpotlightTypes';
import _forEach from 'lodash/forEach';
import { TopCompanyFinancials } from 'Types/CompaniesTypes';
import { Pulse } from 'Types/PulseTypes';
import StatesWidgetSkeleton from 'Components/common/skeleton/StatesWidgetSkeleton';
import ArticleHeroSkeleton from 'Components/common/skeleton/ArticleHeroSkeleton';
import ArticleTileSkeleton from 'Components/common/skeleton/ArticleTileSkeleton';
import { actions as feedIntentDataActions } from 'Slice/FeedIntentDataSlice';
import TagSkeleton from 'Components/common/skeleton/TagSkeleton';
import { Article } from 'Types/ArticleTypes';
import { Waypoint } from 'react-waypoint';
import ProgressBarSkeleton from 'Components/common/skeleton/ProgressBarSkeleton';
import { TOOLTIP_SPOTLIGHT, VIDEO_SPOTLIGHT } from 'Utils/Constants';
import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { IsMobile, valueToObject } from 'Utils/UtilityFunctions';
import classNames from 'classnames';
import {
  selectActivetype, selectHighlight, selectIsHighlighted, selectIsScroll,
} from 'Selector/CertificationSelector';
import ArticleGridGlobal from 'Components/common/components/ArticleGridGlobal';
import StatesWidgetPrimary from '../../common/components/StatesWidgetPrimary';
import { actions as spotlightActions } from '../../../Slice/SpotlightSlice';
import { actions as flurryActions } from '../../../Slice/HelperSlice';
import { actions } from '../../../Slice/UISlice';
import { actions as certificationActions } from '../../../Slice/CertificationSlice';
import TopPeopleAndCompaniesFullSkeleton from './FullComponentSkeletons/TopPeopleAndCompaniesFullSkeleton';
import TopPeopleAndTopCompanies from 'Components/feed/components/TopPeopleAndCompanies';
import HeatMapProgress from '../../common/components/HeatMapProgress';
import ArticleTileGlobal from 'Components/common/components/ArticleTileGlobal';
import TagTip from 'Components/common/components/TagTip';






type Props = {
  listview: boolean;
} & typeof defaultProps;

const defaultProps = {
  listview: false,
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Spotlight = function Spotlight({ listview }: Props) {
  const [spotlightNews, setSpotlightNews] = useState<SpotlightFeed>();
  const [companyStats, setCompanyStats] = useState<SpotlightFeed>();
  const spotlight: SpotlightFeed[] = useSelector(selectSpotlight);
  const spotlightPulseLoading: boolean = useSelector(selectSpotlightPulseLoading);
  const spotlightPulse: Pulse[] = useSelector(selectSpotlightPulse);
  const spotLoading: boolean = useSelector(selectLoading);
  const intentDataLoading: boolean = useSelector(selectIntentLoading);
  const intentData: string[] = useSelector(selectedIntentData);
  const dispatch = useDispatch();
  const host = window.location.href;

  const onEnterFuc = () => {
    dispatch(actions.spotlightInView(true));
  };

  const onLeaveFuc = () => {
    dispatch(actions.spotlightInView(false));
  };

  useEffect(() => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('feed_page_open', 0, {
        host,
      }),
    ));
    dispatch(spotlightActions.getSpotlightData({}));
    dispatch(spotlightActions.getSpotlightPulseData({}));
    dispatch(feedIntentDataActions.getFeedIntentData({}));
  }, []);

  useEffect(() => {
    if (spotlight.length > 0) {
      _forEach(spotlight, (value) => {
        const spotlightData: SpotlightFeed = value;
        if (spotlightData.type === 'popularNews') {
          setSpotlightNews(spotlightData);
        } else if (spotlightData.type === 'companyStats') {
          setCompanyStats(spotlightData);
        }
      });
    }
  }, [spotlight]);
  const articles: Article[] = spotlightNews?.articles || [];
  const isScroll = useSelector(selectIsScroll);
  const isHighlight = useSelector(selectHighlight);
  const currentType = useSelector(selectActivetype);
  const isHighlighted = useSelector(selectIsHighlighted);

  useEffect(() => {
    if (!isHighlighted && !isScroll && currentType === 'spotlight_article_select') {
      dispatch(certificationActions.setHighlight(true));
      dispatch(certificationActions.setIsHighlighted(false));
    }
  }, [isScroll, currentType]);

  return (
    <Waypoint onEnter={onEnterFuc} onLeave={onLeaveFuc}>
      <div className={classNames('spotlight-wrapper spotlight-unique-class spotLightWrapper2 parentClassToHighPrecedence', { highlightedComponent: isHighlight && currentType === 'spotlight_article_select' })}>
        <div className="heading-inner-page">
          <h1 className="heading d-flex align-items-center">
            Spotlight
            <HeadingWithToolTip
              toolTipText={TOOLTIP_SPOTLIGHT}
              videoLink={VIDEO_SPOTLIGHT}
            />
          </h1>
          {!IsMobile() ? (
            <div className="tips-placeholder-spotlight">
              {intentDataLoading ? (
                <>
                  <TagSkeleton />
                  <TagSkeleton />
                </>
              ) : intentData.map((item) => (

                <TagTip key={item} title={item} />

              ))}

            </div>
          ) : null}
        </div>

        <HeatMapProgress
          pulse={spotlightPulse}
          load={spotlightPulseLoading}
        />

        {IsMobile() ? (
          <div className="tips-placeholder-spotlight mb-c-10 flex-wrap">
            {intentDataLoading ? (
              <>
                <TagSkeleton />
                <TagSkeleton />
              </>
            ) : intentData.map((item) => (

              <TagTip key={item} title={item} />

            ))}

          </div>
        ) : null}
        <Row gutter={16} className="spotlight-article-show">
          <Col span={IsMobile() ? 24 : 14} xs={{ order: 2 }} sm={{ order: 2 }} md={{ order: 1 }}>
            {spotLoading ? (
              <Row gutter={16}>
                <Col span={14} xs={24} sm={14}>
                  <ArticleHeroSkeleton />
                </Col>
                <Col span={10} xs={24} sm={10}>
                  <ArticleHeroSkeleton />
                </Col>
              </Row>
            ) : articles?.length > 0
            && (
              <Row gutter={16} className="heroTilesWrapper">
                <Col span={14} xs={24} sm={12} md={12} lg={12}>

                  <ArticleGridGlobal>
                    <div className="articleGridTilesWrapper">
                      <ArticleTileGlobal
                        article={articles[0]}
                        heroArticle
                        articleWidth="314"
                        articleHeight="314"
                        tileClassName="spotlight-heroTile-style"
                        spotlightArticle
                        gridTile
                      />
                    </div>
                  </ArticleGridGlobal>

                </Col>
                {articles?.length > 1
                  ? (
                    <Col span={10} xs={24} sm={12} md={12} lg={12}>

                      <ArticleGridGlobal>
                        <div className="articleGridTilesWrapper">
                          <ArticleTileGlobal
                            article={articles[1]}
                            heroArticle
                            articleWidth="314"
                            articleHeight="314"
                            tileClassName="spotlight-heroTile-style"
                            spotlightArticle
                            gridTile
                          />
                        </div>
                      </ArticleGridGlobal>


                    </Col>
                  ) : null}
              </Row>
            )}
            {IsMobile() ? (
              <>
                {spotLoading ? <ArticleTileSkeleton imageRadius="10px" />
                  : articles?.length > 2 && (

                    <ArticleGridGlobal listView>
                      <ArticleTileGlobal
                        article={articles[2]}
                        articleWidth="72"
                        spotlightMiniTile
                        spotlightArticle
                        tileListView
                        heroArticle
                        listView
                      />
                    </ArticleGridGlobal>

                  )}

                {spotLoading ? <ArticleTileSkeleton imageRadius="10px" />
                  : articles?.length > 3 && (

                    <ArticleGridGlobal listView>
                      <ArticleTileGlobal
                        article={articles[3]}
                        articleWidth="72"
                        spotlightMiniTile
                        spotlightArticle
                        tileListView
                        heroArticle
                        listView
                      />
                    </ArticleGridGlobal>

                  )}
              </>
            ) : null}
          </Col>
          <Col span={IsMobile() ? 24 : 10} xs={{ order: 1 }} sm={{ order: 1 }} md={{ order: 2 }} className="desktopListViewTilesWrapper">
            <Row gutter={16} className="other-states-area">
              {spotLoading ? (
                <>
                  <Col span={8}>
                    <StatesWidgetSkeleton />
                  </Col>
                  <Col span={8}>
                    <StatesWidgetSkeleton />
                  </Col>
                  <Col span={8}>
                    <StatesWidgetSkeleton />
                  </Col>
                </>
              ) : companyStats && companyStats?.results
                .map((item: TopCompanyFinancials) => (
                  <Col span={8}>
                    <StatesWidgetPrimary
                      companyName={item.companyName}
                      title={item.name}
                      state={item.value}
                      key={item.name}
                      sign={item.sign}
                      colorText={item.color}
                      currency={item.currencyCode}
                      currencySymbol={item.currencySymbol}
                      spotlightFlag
                    />
                  </Col>
                ))}

            </Row>
            {!IsMobile() ? (
              <>
                {spotLoading ? <ArticleTileSkeleton imageRadius="10px" />
                  : articles?.length > 2 && (

                    <ArticleGridGlobal listView>
                      <ArticleTileGlobal
                        article={articles[2]}
                        articleWidth="72"
                        spotlightMiniTile
                        spotlightArticle
                        tileListView
                        activityTile
                        heroArticle
                        listView

                      />
                    </ArticleGridGlobal>

                  )}

                {spotLoading ? <ArticleTileSkeleton imageRadius="10px" />
                  : articles?.length > 3 && (

                    <ArticleGridGlobal listView>
                      <ArticleTileGlobal
                        article={articles[3]}
                        articleWidth="72"
                        spotlightMiniTile
                        spotlightArticle
                        tileListView
                        activityTile
                        heroArticle
                        listView
                      />
                    </ArticleGridGlobal>

                  )}
              </>
            ) : null}
          </Col>
        </Row>

        <TopPeopleAndTopCompanies />

      </div>
    </Waypoint>
  );
};

export default Spotlight;
